import {owayoUtils} from "./owayoUtils";
import {MaterialEditor} from "./material/materialEditor";
import {OwayoMaterial} from "./material/owayoMaterial";
import {EnumDictionary} from "./delme_globals";
import {ViewerForMaterial} from "./owayoJSViewerWithSelObs";

export function getCleanMaterialname(name:string) {

    const materialName = owayoUtils.getCleanPartName(name).toLowerCase();
    return materialName.replace(/_optional$/, "")
        .replace(/mitte$/, "")
        .replace(/links$/, "")
        .replace(/rechts$/, "")
        .replace(/left$/, "")
        .replace(/right$/, "");
}

export class OwayoMaterialController {
    parent:ViewerForMaterial;
    materials:EnumDictionary<string, OwayoMaterial>;
    constructor(parent:ViewerForMaterial) {
        this.parent = parent;
        this.materials = {};
    }

    public requestMaterial(part:string, materialName:string) {

        materialName = getCleanMaterialname(materialName);
        if (!this.materials[materialName]) {
            this.materials[materialName] = this.createMaterial(materialName);
        }
        this.materials[materialName].addPart(part);
    }

    protected createMaterial(materialname:string) {
        return new OwayoMaterial(materialname, this.parent);
    }

    openEditor(material:string) {
        const editor = new MaterialEditor(this.materials[getCleanMaterialname(material)]);
        editor.openEditor();
    }
}

